import { AfterViewInit, Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { takeUntil, switchMap,startWith} from 'rxjs/operators';

@Directive({
  selector: '[slideControl]',
  exportAs: 'slideControl'
})
export class SlideControlDirective implements OnInit,AfterViewInit,OnDestroy {
  @Input() itemsLength: number;
  @Input() autoStart:boolean;
  @Input()  selectedIndex:number;
  //selectedIndex = 0;
  
  @Output('selectedIndex')  selectedIndexEmitter = new EventEmitter<number>();
  @Output('actualIndex')  actualIndexEmitter = new EventEmitter<number>();

  destroyed$ = new Subject<void>();
  resetTimer$ = new Subject<void>();
  
  constructor() { }

  ngOnInit(): void {
    //if(this.autoStart != undefined && this.autoStart == true){
      this.resetTimer$.pipe(
        startWith(null),
        takeUntil(this.destroyed$),
        switchMap(t => timer(5000, 5000))
      ).subscribe(() => this.next())
    //}
    
  }

  ngAfterViewInit():void{
    if(this.autoStart != undefined && this.autoStart == true){
      this.resetTimer$.pipe(
        startWith(10),
        takeUntil(this.destroyed$),
        switchMap(t => timer(8000, 8000))
      ).subscribe(() => this.next())
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
  }
  actualIndex() {
    let len = this.itemsLength;
    // negative still return the right index
    //console.log({actualIndex:((this.selectedIndex % len) + len) % len});
    return ((this.selectedIndex % len) + len) % len;
  }
  setIndex(index: number) {
    if(index > this.itemsLength-1){
      index = 0;
    }
    this.selectedIndex = index;
    this.actualIndexEmitter.next(this.actualIndex())
    this.selectedIndexEmitter.next(index)
    this.resetTimer$.next();
  }

  previous() {
    --this.selectedIndex;
    console.log("Previous clicked");
    this.actualIndexEmitter.next(this.actualIndex());
    this.selectedIndexEmitter.next(this.selectedIndex);
    this.resetTimer$.next();
  }
  next() {
    console.log("Next clicked");
    ++this.selectedIndex;
    console.log(this.selectedIndex);
    this.actualIndexEmitter.next(this.actualIndex())
    this.selectedIndexEmitter.next(this.selectedIndex)
    this.resetTimer$.next();
  }

}
